// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","item":"Header_item__OOEY7"};